import React, { useEffect, useState } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { AppProvider } from '@shopify/polaris';
import { AccountClient } from '@nile/graphql';
import InvoiceDetails from '@nile/client_management/src/Pages/Invoice/InvoiceDetails';
import envConfig from '@nile/home/src/Config/env';
import styled from 'styled-components';
import InvoiceDetailsPDF from './InvoiceDetailsPdf';

const PDFWrap = styled.div`
  .Polaris-Page__Content {
    overflow: unset !important;
  }
`;

function PDFPage(props) {
  const { match } = props;
  useEffect(() => {
    document.body.style.overflow = 'auto';
  }, []);
  const invoiceId = props.invoiceId || match?.params?.id || null;
  return (
    <PDFWrap className="vignesh">
      <AppProvider>
        <InvoiceDetailsPDF
          invoiceId={invoiceId}
          accountClient={AccountClient}
        />
      </AppProvider>
    </PDFWrap>
  );
}

export default withRouter(PDFPage);
